import React from 'react'
import { Section, TwoColVideo } from 'newComponents'

import './styles.scss'

const TwoColumnImageTextRepeater = (props) => {
  const {
    data: {
      items,
      primary: { title, tagline }
    }
  } = props

  const titleHtml = title?.html
  const taglineHtml = tagline?.html

  return (
    <Section className="two-cols-video-text">
      {titleHtml && (
        <div className="feature-block-title">
          <h2>{titleHtml}</h2>
          <p>{taglineHtml}</p>
        </div>
      )}
      <div className="two-column-image-text-repeater-containers">
        {items.map((item) => (
          <TwoColVideo key={item.content.text} item={item} />
        ))}
      </div>
    </Section>
  )
}

export default TwoColumnImageTextRepeater
